import { render, staticRenderFns } from "./SwitchAccountFiles/SwitchAccount.html?vue&type=template&id=e81e34a0&scoped=true&external"
import script from "./SwitchAccountFiles/SwitchAccount.js?vue&type=script&lang=js&external"
export * from "./SwitchAccountFiles/SwitchAccount.js?vue&type=script&lang=js&external"
import style0 from "./SwitchAccountFiles/SwitchAccount.scss?vue&type=style&index=0&id=e81e34a0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81e34a0",
  null
  
)

export default component.exports